/* eslint-disable @typescript-eslint/no-var-requires */
import auMenu from './AU.json';
import nzMenu from './NZ.json';
import usMenu from './US.json';
import sgMenu from './SG.json';
import caMenu from './CA.json';
import ukMenu from './UK.json';
import frMenu from './FR.json';
import deMenu from './DE.json';
import esMenu from './ES.json';
import itMenu from './IT.json';
import seMenu from './SE.json';
import ieMenu from './IE.json';
import nlMenu from './NL.json';
import atMenu from './AT.json';
import beMenu from './BE.json';
import ptMenu from './PT.json';
import fiMenu from './FI.json';
import { HorizontalMenuItem } from './types';

let menu = auMenu;

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-au') {
  menu = auMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-nz') {
  menu = nzMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-dev') {
  menu = auMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-us') {
  menu = usMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-ca') {
  menu = caMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-uk') {
  menu = ukMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-fr') {
  menu = frMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-de') {
  menu = deMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-es') {
  menu = esMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-it') {
  menu = itMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-se') {
  menu = seMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-ie') {
  menu = ieMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-nl') {
  menu = nlMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-at') {
  menu = atMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-be') {
  menu = beMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-pt') {
  menu = ptMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'reebelo-fi') {
  menu = fiMenu;
}

if (process.env.NEXT_PUBLIC_STORE === 'quista') {
  menu = sgMenu;
}

export default menu as HorizontalMenuItem[];
